<script>
import AcceptCollectionDetail from '@/driver/pages/orders/shared/_AcceptCollectionDetail.vue'
import RequestCarryInDetail   from '@/driver/pages/orders/shared/_RequestCarryInDetail.vue'
import AcceptPickupDetail     from '@/driver/pages/orders/shared/_AcceptPickupDetail.vue'

/**
 * 受注詳細参照モーダル
 */
export default {
  name: "OrderDetailModal",
  components: {
    AcceptCollectionDetail,
    AcceptPickupDetail,
    RequestCarryInDetail,
  },
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false
    },
    /**
     * 受注ID
     * @property orderId { Number }
     */
    orderId: {
      type: Number,
      default: () => null
    },
    /**
     * 受注種別
     * @property orderType { String }
     */
    orderType: {
      type: String,
      default: 'collection'
    },
  },
  data() {
    return {
      visibleRegisterButton: false,
    }
  },
  computed: {
  },
  watch: {
    /**
     * 本モーダル表示制御フラグの監視
     */
    enableDialog () {
      // 登録ボタンを非表示に変更
      this.visibleRegisterButton = false;
    },
  },
  created() {
  },
  methods: {
    /**
     * 更新ボタン クリックイベント
     */
    registerButtonClickEvent () {
      if (this.orderType === 'pickup') {
        this.$refs.pickupDetail.updateButtonClickEvent();
      }
    },
    /**
     * モーダル内での更新完了のコールバック
     * 親画面のリロードをコールバック
     */
    refreshCallback () {
      this.$emit('modalRefreshCallback')
    },
    /**
     * 閉じるボタン クリックイベント
     */
    closeButtonClickEvent() {
      this.$emit('closeCallback')
    },
    /**
     * 引取詳細からのボタン制御用フラグの返却及び本モーダル登録ボタンの表示制御
     * @param value
     */
    pickupStatusCallback (value) {
      this.visibleRegisterButton = value
    },
    orderTypeName () {
      if (this.orderType === 'collection') {
        return "産廃"
      } else if (this.orderType === 'general') {
        return "一廃"
      } else if (this.orderType === 'pickup') {
        return "積替"
      } else if (this.orderType === 'carryin') {
        return `搬入`
      }
    },
  }
}
</script>

<template>
<v-dialog
  :value="enableDialog"
  fullscreen
  persistent
  scrollable
  transition="dialog-bottom-transition"
  @keydown.esc="closeButtonClickEvent"
  @close="closeButtonClickEvent"
>
  <v-card
    flat
  >
    <v-card-title class="primary white--text">
      受注詳細（{{ orderTypeName() }}）
      <v-spacer />
      <v-btn
        dark
        icon
        @click="closeButtonClickEvent"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <accept-collection-detail
        v-if="['collection', 'general'].includes(orderType)"
        caller-type="modal"
        :order-id="orderId"
        :order-type="orderType"
        @refreshCallback="refreshCallback"
      />
      <accept-pickup-detail
        v-else-if="orderType === 'pickup'"
        ref="pickupDetail"
        caller-type="modal"
        :order-id="orderId"
        @refreshCallback="refreshCallback"
        @statusCallback="pickupStatusCallback"
      />
      <request-carry-in-detail
        v-else-if="orderType === 'carryin'"
        caller-type="modal"
        :order-id="orderId"
        @refreshCallback="refreshCallback"
      />
    </v-card-text>
    <v-divider />
    <v-card-actions>
      <v-spacer />
      <v-btn
        :class="{ 'mr-15': !visibleRegisterButton }"
        @click="closeButtonClickEvent"
      >
        閉じる
      </v-btn>
      <v-btn
        v-if="visibleRegisterButton"
        class="mr-15"
        color="primary"
        @click="registerButtonClickEvent"
      >
        更新
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<style scoped lang="scss">

</style>
